module.exports = __webpack_public_path__ + "img/user.f0783204.svg";